import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Divider } from 'react95-native-rabbl';
import * as AppUtilities from "@/utilities/AppUtilities";

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
});

interface Props {
  fullWidth?: boolean,
  margin?: boolean,
  marginBottom?: boolean,
  marginTop?: boolean,
  style?: StyleProp<ViewStyle>,
};

export function CustomDivider({
  fullWidth = true,
  margin = false,
  marginBottom = false,
  marginTop = false,
  style,
}: Props) : React.ReactNode {
  if (AppUtilities.isWeb()) {
    return (
      <View
        style={[
          styles.container,
          {
            ...( fullWidth && { width: "100%" } )
          },
          {
            ...( margin && { marginVertical: 20 } )
          },
          {
            ...( marginBottom && { marginBottom: 20 } )
          },
          {
            ...( marginTop && { marginTop: 20 } )
          },
        ]}
      >
        <Divider />
      </View>
    );
  } else {
    return (
      <View
        style={[
          {
            ...( fullWidth && { width: "100%" } )
          },
          {
            ...( margin && { marginVertical: 20 } )
          },
          {
            ...( marginBottom && { marginBottom: 20 } )
          },
          {
            ...( marginTop && { marginTop: 20 } )
          },
          {
            borderTopWidth: 2,
            borderTopColor: "#808080",
            borderBottomWidth: 1,
            borderBottomColor: "#ffffff",
          },
          style
        ]}
      >
      </View>
    );
  }
};
